import { Svg, Tooltip } from '@hopskipdrive/react-components';
import BoltIcon from '@mui/icons-material/Bolt';
import EventSeatRoundedIcon from '@mui/icons-material/EventSeatRounded';
import FamilyRestroomRoundedIcon from '@mui/icons-material/FamilyRestroomRounded';
import VideoCameraFrontRoundedIcon from '@mui/icons-material/VideoCameraFrontRounded';
import WheelchairPickupRoundedIcon from '@mui/icons-material/WheelchairPickupRounded';
import { Box, Icon } from '@mui/material';
import { colorPalette, colorTokens } from '@rideiq/shared/components/variables';

import { VestIcon } from './VestIcon';

const iconStyles = {
  color: 'white',
  borderRadius: '50%',
  backgroundColor: colorPalette.green70,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px',
  Svg: {
    marginRight: '0 !important',
  },
};

const mbmIconStyles = {
  ...iconStyles,
  backgroundColor: colorTokens.warning.dark,
  padding: undefined, // Remove padding for mbm if not needed
  Svg: {
    marginRight: '0 !important',
  },
};

const serviceIconMap: Record<string, JSX.Element> = {
  WAV: <WheelchairPickupRoundedIcon fontSize="large" sx={iconStyles} />,
  DR: <VideoCameraFrontRoundedIcon fontSize="large" sx={iconStyles} />,
  AR: <VideoCameraFrontRoundedIcon fontSize="large" sx={iconStyles} />,
  CS: <EventSeatRoundedIcon fontSize="large" sx={iconStyles} />,
  RA: <FamilyRestroomRoundedIcon fontSize="large" sx={iconStyles} />,
  MBM: (
    <Icon fontSize="large" sx={mbmIconStyles}>
      <Svg icon="handoff" width="24px" height="24px" color="white" />
    </Icon>
  ),
  SR: <BoltIcon fontSize="large" sx={iconStyles} />,
  SV: (
    <Icon fontSize="large" sx={iconStyles}>
      <VestIcon sx={{ color: 'white', width: '16px' }} />
    </Icon>
  ),
};

export const SERVICE_ICON_CODES = Object.keys(serviceIconMap);

interface RiderServicesProps {
  services: Pick<RiderService, 'code' | 'name'>[];
}

export const RiderServices: React.FC<RiderServicesProps> = ({ services }) => (
  <Box display="flex" alignItems="center" gap="12px" flexWrap="wrap">
    {services.map(
      ({ code, name }) =>
        serviceIconMap[code] && (
          <Tooltip key={code} title={name}>
            <Box
              component="span"
              role="img"
              aria-label={name}
              tabIndex={0}
              display="flex"
              alignItems="center"
              gap="4px"
              sx={{
                '&:focus-visible': {
                  outline: `2px solid ${colorTokens.primary.main}`,
                  outlineOffset: '2px',
                },
              }}
            >
              {serviceIconMap[code]}
            </Box>
          </Tooltip>
        )
    )}
  </Box>
);
